
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1a4.92 4.92 0 014.918 4.923c0 .83-.206 1.633-.58 2.321l-.105.215-.024.044-3.584 6.153a.692.692 0 01-1.195.004L3.767 8.458l-.04-.082-.025-.05a5.906 5.906 0 00-.052-.103 4.909 4.909 0 01-.568-2.3A4.92 4.92 0 018 1zm0 3.682a1.489 1.489 0 10.002 2.977A1.489 1.489 0 008 4.682z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    